import { DiJavascript1, DiReact, DiMongodb } from "react-icons/di";
import { SiNextdotjs, SiRedux } from "react-icons/si";
import { FaNodeJs } from "react-icons/fa";

const skillList = [
  {
    name: "Intermediate JavaScript",
    percentage: "90",
    Icons: <DiJavascript1 className="text-7xl text-own-secondary" />,
  },
  {
    name: "Advance React",
    percentage: "90",
    Icons: <DiReact className="text-7xl text-own-secondary" />,
  },
  {
    name: "intermediate NextJs",
    percentage: "90",
    Icons: <SiNextdotjs className="text-7xl text-own-secondary" />,
  },
  {
    name: "intermediate NodeJs",
    percentage: "90",
    Icons: <FaNodeJs className="text-7xl text-own-secondary" />,
  },
  {
    name: "intermediate MongoDB",
    percentage: "90",
    Icons: <DiMongodb className="text-7xl text-own-secondary" />,
  },
  {
    name: "intermediate Redux",
    percentage: "90",
    Icons: <SiRedux className="text-7xl text-own-secondary" />,
  },
];

export default skillList;
